<script>
    import { onMount } from 'svelte';
    import { push } from 'svelte-spa-router';
    import * as qs from 'qs';
    import configs from '../../config';

    export let params = {};

    let loading = true;
    let notfound = false;
    let item = null;

    function fmtDate(u) {
        if (!u) return '';
        try { return new Date(Number(u) * 1000).toLocaleString('th-TH', { dateStyle: 'long', timeStyle: 'short' }); }
        catch (e) { return ''; }
    }

    async function load() {
        loading = true;
        notfound = false;
        try {
            const res = await fetch(configs.cloudapi + '/push/campaign', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-api-appid': window.localStorage.getItem('appid'),
                },
                body: qs.stringify({ _id: params.id }),
            });
            const j = await res.json();
            if (j.statusCode === 200 && j.payload) item = j.payload;
            else notfound = true;
        } catch (e) {
            notfound = true;
        }
        loading = false;
    }

    onMount(load);
</script>

<svelte:head>
    <title>{item ? item.title : 'ข่าวสาร'}</title>
</svelte:head>

<div class="news-wrap">
    <div class="news-top">
        <button class="news-back" on:click={() => push('/dashboard')}>‹ กลับ</button>
    </div>

    {#if loading}
        <div class="news-state">กำลังโหลด...</div>
    {:else if notfound}
        <div class="news-state">ไม่พบข่าวนี้ หรือถูกลบไปแล้ว</div>
    {:else}
        <div class="news-card">
            {#if item.image_url}
                <img class="news-img" src={item.image_url} alt={item.title} />
            {/if}
            <h2 class="news-title">{item.title}</h2>
            {#if item.sent_at || item.gentime}
                <div class="news-date">{fmtDate(item.sent_at || item.gentime)}</div>
            {/if}
            {#if item.body}
                <div class="news-body">{item.body}</div>
            {/if}
            {#if item.content}
                <div class="news-content">{@html item.content}</div>
            {/if}
        </div>
    {/if}
</div>

<style>
    .news-wrap { padding: 12px 14px 40px; color: #fff; }
    .news-top { margin-bottom: 10px; }
    .news-back {
        background: rgba(255,255,255,.08);
        border: 1px solid rgba(230,196,119,.4);
        color: #e6c477;
        border-radius: 8px;
        padding: 6px 14px;
        font-size: .9rem;
        cursor: pointer;
    }
    .news-state { text-align: center; padding: 40px 0; color: #ccc; }
    .news-card {
        background: rgba(20,20,20,.85);
        border: 1px solid rgba(230,196,119,.3);
        border-radius: 12px;
        overflow: hidden;
        padding: 0 0 16px;
    }
    .news-img { width: 100%; max-height: 220px; object-fit: cover; display: block; }
    .news-title { color: #e6c477; font-weight: 600; font-size: 1.15rem; padding: 14px 14px 4px; margin: 0; }
    .news-date { font-size: .72rem; color: #999; padding: 0 14px 8px; }
    .news-body { font-size: .9rem; color: #ddd; padding: 0 14px 8px; }
    .news-content { font-size: .88rem; line-height: 1.7; padding: 0 14px; }
    .news-content :global(img) { max-width: 100%; height: auto; border-radius: 8px; }
    .news-content :global(a) { color: #e6c477; }
</style>
